import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { push } from "react-router-redux";
import Input from "../../../../components/form/Input";
import Password from "../../../../components/form/Password";
import DatePicker from "../../../../components/form/DateTime";
import Button from "../../../../components/form/Button";
import CroField from "../generalForm/CroField";
import CroLabeledCmp from "../generalForm/CroLabeledCmp";
import FinancialInstitutionsHistoryGrid from "../../components/grids/FinancialInstitutionsHistoryGrid";
import { styles } from "../../index";
import { asyncForm } from "../../../../utils/asyncForm";
import { generateLogin } from "../../CroActions";
import askAction from "../AskAction";
import * as V from "../../../../utils/formValidation";
import { isPublic } from "../../CroUtils";


const minLength8 = V.minLength(8);

class FinancialinstitutionsForm extends Component {
  state = {
    historyVisible: false,
  };

  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  generateLogin = (data) => async () => {
    const { change, dispatch, auth } = this.props;
    const { username, password } = await generateLogin(
      `${auth.startUrl}/api/financni-instituce/prihlasovaci-udaje/generovat`,
      dispatch,
      data,
    );

    change("username", username);
    change("plainPassword", password);
  };

  disableGen = () => {
    const { name } = this.props.loginData;
    return !name;
  };

  showOfficialHistory = () => {
    this.setState({ historyVisible: true });
  };

  hideOfficialHistory = () => {
    this.setState({ historyVisible: false });
  };

  onRowClick =
    () =>
    ({ official }) => {
      const { auth, params } = this.props;
      this.props.dispatch(
        push(`${auth.startUrl}/funkcionari/form/${official.id}/`),
      );
    };

  render() {
    const {
      error,
      handleSubmit,
      onSubmit,
      onDelete,
      submitting,
      disabled,
      loginData,
      askAction,
      allowBasic,
      isNew,
      auth,
      params,
      statementClick,
    } = this.props;
    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form long-label financialInstitutionsForm"
      >
        <div className="financialInstitutionsForm__section financialInstitutionsForm__fullWidth">
          <div className="financialInstitutionsForm__grid financialInstitutionsForm__grid--top">
            <CroField
              className="half"
              title="IČO"
              name="ic"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Název"
              name="name"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Email"
              name="email"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.email]}
              hintText="@"
            />
            <CroField
              className="half"
              title="Kontaktní osoba"
              name="contactPerson"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Tel. číslo"
              name="phone"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
          </div>
        </div>

        <div className="financialInstitutionsForm__section financialInstitutionsForm__fullWidth">
          <div className="financialInstitutionsForm__grid">
            <CroField
              className="half"
              title="Přihlašovací jméno"
              name="username"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Heslo"
              name="plainPassword"
              component={Password}
              fullWidth
              disabled={disabled}
              validate={[V.required, minLength8]}
            />
          </div>
        </div>

        <div className="financialInstitutionsForm__section financialInstitutionsForm__fullWidth">
          <div className="financialInstitutionsForm__grid">
            <CroField
              className="half"
              title="Platnost od"
              name="accountValidityFrom"
              component={(props) => <DatePicker {...props} useISO />}
              noIcon
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Platnost do"
              name="accountValidityTo"
              component={(props) => <DatePicker {...props} useISO />}
              noIcon
              disabled={disabled}
              validate={[V.required]}
            />
          </div>
        </div>

        <div className="financialInstitutionsForm__section financialInstitutionsForm__fullWidth">
          <div className="financialInstitutionsForm__grid">
            <div style={{ gridColumn: '1 / -1' }}>
              <CroField
                title="Poznámka"
                name="note"
                component={Input}
                fullWidth
                disabled={disabled}
                multiline
                rows={4}
                maxlen={1000}
              />
            </div>
          </div>
        </div>

        {!disabled && (
          <div className="financialInstitutionsForm__footer">
            <div className="financialInstitutionsForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="financialInstitutionsForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="financialInstitutionsForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Zpět"
                  disabled={submitting || disabled}
                  onClick={() =>
                    this.props.dispatch(
                      push(`${auth.startUrl}/financni-instituce`),
                    )
                  }
                />
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
                {!isNew && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Smazat"
                    disabled={submitting || disabled}
                    onClick={askAction(
                      onDelete,
                      "Opravdu chcete smazat finanční instituce?",
                    )}
                  />
                )}
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Generovat jméno a heslo"
                  disabled={submitting || disabled || this.disableGen()}
                  onClick={this.generateLogin(loginData)}
                />
                {!this.state.historyVisible && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zobrazit historii"
                    onClick={this.showOfficialHistory}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        {this.state.historyVisible && (
          <div className="financialInstitutionsForm__section financialInstitutionsForm__fullWidth">
            <CroLabeledCmp title="Historie činností">
              <FinancialInstitutionsHistoryGrid
                gridName="financialHistoryPositionLocalGrid"
                url={`${auth.startUrl}/api/financni-instituce/${params.id}/historie`}
                items={this.state.financialInstitutionsHistoryItems}
                hidding={this.state.historyVisible}
                onAdd={this.hideOfficialHistory}
                onRowClick={this.onRowClick()}
                filtering={false}
                canNotOpen={isPublic(auth)}
              />
            </CroLabeledCmp>
          </div>
        )}
      </form>
    );
  }
}

export default reduxForm({
  form: "financialinstitutionsForm",
  initialValues: { allowBasic: true },
})(askAction(asyncForm(FinancialinstitutionsForm)));
